import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import IssuerDetail from '../components/IssuerDetail.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'cert-manager.io.clusterissuer',
  props: {
    value: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IssuerDetail, { value: __props.value }, null, 8, ["value"]))
}
}

})